export const permissionsHave = () => {
  const accesshave = [
    {
      label: "User Management",
      value: "用户管理"
    },
    {
      label: "Payment Management",
      value: "收款管理"
    },
    {
      label: "Course Purchase",
      value: "课程购买"
    },
    {
      label: "Product Purchase",
      value: "产品购买"
    },
    {
      label: "Magazine Management",
      value: "杂志管理"
    },
    {
      label: "New Management",
      value: "资讯管理"
    },
    // {
    //   label: "Promotion Management",
    //   value: "促销管理"
    // },
    {
      label: "Education Management",
      value: "教育管理"
    },
    {
      label: "Product Management",
      value: "产品管理"
    },
    {
      label: "Ads Settings",
      value: "广告设置"
    },
    {
      label: "Staff Management",
      value: "账户管理"
    },
    {
      label: "Featured Works",
      value: "主题作品"
    },
    {
      label: "Men's / Women's / Avant-Garde Creativity",
      value: "男/女/前卫创意"
    },
    {
      label: "Technology Display",
      value: "技术展示"
    },
    {
      label: "Banner Management",
      value: "横幅"
    },
    {
      label: "Coupon Management",
      value: "代惠券管理"
    }
  ]
  return accesshave
}

export const permissionsData =["用户管理","收款管理","杂志管理","资讯管理","教育管理","账户管理", "课程购买", "产品购买", "产品管理", "广告设置", "主题作品", "男/女/前卫创意", "冷知识", "技术展示" ,"横幅", "代惠券管理"]
//